<template>
  <div>
    <!-- Button -->
    <a class="delete" @click="open" :record="record">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>Delete Icon</title>
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" fill-rule="nonzero"/>
      </svg>
      <slot>Delete</slot>
    </a>
    <!-- Confirmation Dialog -->
    <confirm-dialog v-if="active" @confirm="confirm" @cancel="cancel" :loading="loading" confirm-text="Confirm" cancel-text="Cancel">
      <h3>Delete SKU</h3>
      <p>Are you sure? This action cannot be undone.</p>
    </confirm-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import ConfirmDialog from '../ConfirmDialog'

  export default {
    components: {
      ConfirmDialog
    },
    props: [
      'record'
    ],
    data() {
      return {
        active: false,
        loading: false,
      }
    },
    methods: {
      cancel() {
        this.active = false;
        this.loading = false;
      },
      open() {
        this.active = true;
      },
      confirm() {
        this.loading = true;
        axios.post('/configurator-module/api/clipboard/delete', {
          [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
          id: this.record.id
        })
        .then((response) => {
          this.$emit('refresh');
          setTimeout(() => {
            this.cancel();
          }, 2000)
        })
        .catch((error) => {
          console.log(error);
        });
      }
    },
  }
</script>
